import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import { useTitle } from "@/utils/react/useTitle.ts";
import type { ReactNode } from "react";

export function ViewTitle({
    title,
    children,
    ...props
}: { title: Translatable } & BaseProps & { children?: ReactNode }) {
    useTitle(title);

    return (
        // NB: `flex` is needed to lay out the optional `children` (eg. badges) next to the title.
        <h1 {...mcn("font-size-heading flex", props)}>
            {title}
            {children}
        </h1>
    );
}
